import ScrollReveal from "scrollreveal";
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import { gsap, ScrollTrigger, ExpoScaleEase, Expo } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, ExpoScaleEase, Expo);
Splitting();

jQuery(document).ready(function ($) {

    $(".animsition").animsition({
        inClass: 'fade-in-down',
        outClass: 'fade-out-down',
        inDuration: 800,
        outDuration: 800,
        linkElement: 'a:not([target="_blank"]):not([href^="#"]):not([aria-current="page"]):not(.ab-item):not([href^="nolink"]):not([href^="https://nolink"]):not([href^="http://nolink"]):not([href^="mailto:"]):not([href^="tel:"]):not([data-target]):not(.disable-animsition):not(.cc-dismiss):not(.site-menu-nav-dropdown-toggle):not(.added_to_cart_button):not(.woocommerce-MyAccount-downloads-file)',
        loading: false,
        timeout: true,
        timeoutCountdown: 500,
        onLoadEvent: true,
        browser: ['animation-duration', '-webkit-animation-duration'],
        overlay: false,

    });



    if ($("body").hasClass("home")) {
        setTimeout(function () {
            $("body").removeClass("overflow-hidden");
            $('#preloader').fadeOut(800);
        }, 600);
        initAll();
    } else {
        setTimeout(function () {
            $("body").removeClass("overflow-hidden");
            $('#preloader').fadeOut(300);
        }, 300);
        initAll();
    }

    function initAll() {
        var staggerUp = {
            duration: 600,
            interval: 100,
            distance: '50px',
            viewFactor: 0.75,
            easing: 'ease',
            delay: 100,
        };

        // Animated elements selectors
        let staggerAnimationElements = [
            '.fade-in-item, #cta-section .container .content-wrapper > *',
            '#our-partners-section .container > *',
            '#our-vision .container .col > *',
            '.tax-partner_category main > *',
            '.page-template-contact-page main .container .col-form form .wrapper > *',
            '#our-services .wrapper'
        ]
        // Tweak Animation on mobile
        if ($(window).width() <= 760) {
            staggerAnimationElements = staggerAnimationElements.filter(e => e !== '#our-services .wrapper');
            // Add new Elements
            staggerAnimationElements.push('#our-services .wrapper .service-card');
        }
        // init animation of elements
        for (let i = 0; i < staggerAnimationElements.length; i++) {
            ScrollReveal().reveal(staggerAnimationElements[i], staggerUp);
        }

        // Text animation
        $(".animate-text").each(function () {
            var text = $(this);
            var characters = text.find(".char");

            const textTimeline = gsap.timeline({

                scrollTrigger: {
                    trigger: text,
                    start: "top 75%",
                    // markers: true,
                },
            });

            textTimeline.to(characters, { duration: 0.5, stagger: 0.01, ease: Expo.easeOut, transform: 'translateY(0)' });
        });
        // Body text animation
        $(".animate-text-body").each(function () {
            var text = $(this);
            var characters = text.find(".char");

            const textTimeline = gsap.timeline({

                scrollTrigger: {
                    trigger: text,
                    start: "top 75%",
                    // markers: true,
                },
            });

            textTimeline.to(characters, { duration: 0.7, stagger: 0.005, ease: Expo.easeOut, transform: 'translateY(0)' });
        });
        $(".animate-ltr").each(function () {
            var text = $(this);
            var characters = text;

            const textTimeline = gsap.timeline({

                scrollTrigger: {
                    trigger: text,
                    start: "top 55%",
                    // markers: true,
                },
            });

            textTimeline.to(characters, { duration: 2.2, stagger: 0.005, ease: Expo.easeOut, transform: 'translateX(0)' });
        });
    }
});